// @flow

const isMobile = require('ismobilejs');
// const $ = require('jquery');

const DEFAULTS = {
	selector:      'span.phone-number',
	linkClassName: 'phone-number',
	domChange:     true,
};

/**
 * Detect phone numbers by given selector and transform them into anchors when viewed on Cell phone
 * @param element
 * @param options
 * @constructor
 */
const PhoneLinkActivation = function (element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;

	this.observer = null;

	this._initialise();
};

/**
 * init function, detect and run, if needed
 * @private
 */
PhoneLinkActivation.prototype._initialise = function () {
	/**
	 * init mobile detection
	 */
	this.isMobile = isMobile;

	/**
	 * we really don't need it, if we don't have a phone
	 */
	if ( !this.isMobile.phone ) {
		return false;
	}

	/**
	 * get all unprocessed phone number elements and process them
	 */
	this.getRelevantElements();

	/**
	 * start MutationObserver()
	 * browsers not supporting MutationObserver we can ignore
	 */
	if ( this.options.domChange ) {
		this._initMutationObserver();
	}
};

/**
 * init DOM changes detection for most modern browsers
 * @private
 */
PhoneLinkActivation.prototype._initMutationObserver = function () {
	// FF, Chrome, Safari, iOS, Android, IE11+
	if ( window.MutationObserver ) {
		this.observer = new MutationObserver((mutations, observer) => {
			this.getRelevantElements();
		});
		this.observer.observe(this.element, {
			childList: true,
			subtree:   true,
		});
	}
};

/**
 * the only public method, gets elements according to the selector in options and send them to be processed
 */
PhoneLinkActivation.prototype.getRelevantElements = function () {
	this.elements = [ ...this.element.querySelectorAll(this.options.selector) ];
	this._processPhoneNumbers();
};

/**
 * iterates through the collected elements, marks them not to be processed twice and calls transformation to anchor
 * @private
 */
PhoneLinkActivation.prototype._processPhoneNumbers = function () {
	this.elements.forEach((item) => {
		/**
		 * proces only non-flagged spans - to be sure not to add anchor twice in a row (due to MutationObserver)
		 */
		if ( item.dataset && !item.dataset.phoneLinkActivationApplied ) {
			this._changePhoneElementToAnchor(item);
		}
	});
};

/**
 * transforms `phoneNumberElement` into an anchor with tel:
 * @param phoneNumberElement
 * @private
 */
PhoneLinkActivation.prototype._changePhoneElementToAnchor = function (phoneNumberElement) {
	phoneNumberElement.dataset.phoneLinkActivationApplied = 1;

	const phoneNumber = phoneNumberElement.textContent.trim().replace(/\s/gi, '');
	const anchor = document.createElement('a');
	anchor.textContent = phoneNumberElement.textContent;
	anchor.setAttribute('class', `${ this.options.linkClassName } ${ phoneNumberElement.className.replace(this.options.linkClassName, '') }`);
	anchor.setAttribute('href', `tel://${ phoneNumber }`);
	// clone all attributes from original span
	if ( phoneNumberElement.hasAttributes() ) {
		const { attributes } = phoneNumberElement;
		for ( let i = attributes.length - 1; i >= 0; i-- ) {
			anchor.setAttribute(attributes[ i ].name, attributes[ i ].value);
		}
	}
	phoneNumberElement.parentNode.appendChild(anchor);
	phoneNumberElement.parentNode.removeChild(phoneNumberElement);
};

module.exports = PhoneLinkActivation;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/phoneLinkActivation.js